<template>
    <div>
        <PercoInstallationPanel />
    </div>
</template>

<script>
import PercoInstallationPanel from '../../components/perco-info/PercoInstallationPanel';

export default {
    name: 'RecommendationTableView',
    components: {
        PercoInstallationPanel,
    },
}
</script>

<style scoped></style>
